import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';

export function createAnalystQueries(client: StoxlyClient) {
  return createQueryKeys('analyst', {
    // ['analyst', 'detail', analystId]
    detail: (analystId: string) => ({
      queryKey: [analystId],
      queryFn: ({ signal }) =>
        client.analystEntitiesGetAnalyst({ params: { id: analystId }, signal }),
    }),
  });
}
